<template>
  <div>
    <!-- <CHeader fixed with-subheader light class="d-flex justify-content-between fixed-nav"> -->
    <CHeader class="c-header c-header-light c-header-fixed c-header-with-subheader">
      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3" target="_self">
          <a href="Crm">
            <img src="img/logo_wapiti.png" width="200px" class="my-2"/></a>
        </CHeaderNavItem>
      </CHeaderNav>
      <CHeaderNav v-show="city" class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3">
          <h4>
            <em style="font-size: 1rem">{{ city }} {{ temp }}°C </em>
            <img style="margin-left: 5px; max-width: 42px" :src="ico_meteo"
              v-c-tooltip="{ content: desc_meteo, placement: 'bottom-end' }" />
          </h4>
        </CHeaderNavItem>
      </CHeaderNav>
      <CHeaderNav class="mr-4">
        <TheHeaderDropdownAccnt @set-loading="setLoading" />
      </CHeaderNav>
    </CHeader>
  </div>
</template>

<script>
import { cilArrowCircleLeft } from "@coreui/icons";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import axios from "axios";

export default {
  name: "TheHeader",
  back_ico: cilArrowCircleLeft,
  components: {
    TheHeaderDropdownAccnt,
  },
  data() {
    return {
      city: null,
      temp: null,
      desc_meteo: null,
      ico_meteo: null,
      interval: null,
      check_ver: null,
    };
  },
  mounted() {
    this.meteo();
  },
 
  methods: {
    // attiva/disattiva il loader, emettendo un evento
    // che viene ascoltato da TheContainer
    // se specificato un timeout, il loader torna allo stato precedente
    setLoading(is_loading, timeout_ms = null) {
      this.$emit("set-loading", is_loading, timeout_ms);
    },

   
    meteo() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    },
    showPosition(position) {
      // console.log("Latitudine: " + position.coords.latitude);
      // console.log("Longitudine: " + position.coords.longitude);
      let latitude = position.coords.latitude;
      let longitude = position.coords.longitude;
      // console.log("url meteo " + this.$custom_json.url_meteo);
      let url =
        this.$custom_json.url_meteo +
        "?appid=" +
        this.$custom_json.token_meteo +
        "&lat=" +
        latitude +
        "&lon=" +
        longitude +
        "&units=metric&lang=it";

      try {
        axios.get(url).then((response) => {
          // console.log("Dati meteo: " + JSON.stringify(response.data.name));
          this.city = response.data.name;
          this.temp = response.data.main.temp.toString().split(".")[0];
          this.desc_meteo = response.data.weather[0].description;
          this.ico_meteo =
            "img/meteo/" + response.data.weather[0].icon + ".png";
        });
      } catch (error) {
        console.log("impossibile recuperare i dati meteo" + error);
      }
    },
    
   
  },
};
</script>
